"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";

// Footer with legal links — rendered at the bottom of every in-app page (via AppShell)
// and on the standalone /legal page. Links deep-link to the matching document anchor.
const LEGAL_LINKS: {
  id: string;
  key: "about" | "terms" | "privacy" | "kvkk" | "consent" | "cookies" | "distanceSales" | "deliveryRefund";
}[] = [
  { id: "about", key: "about" },
  { id: "terms", key: "terms" },
  { id: "privacy", key: "privacy" },
  { id: "kvkk", key: "kvkk" },
  { id: "consent", key: "consent" },
  { id: "cookies", key: "cookies" },
  { id: "distance-sales", key: "distanceSales" },
  { id: "delivery-refund", key: "deliveryRefund" },
];

export function Footer({
  legalBase = "/legal",
  className = "",
}: { legalBase?: string; className?: string } = {}) {
  const t = useTranslations("footer");
  const year = new Date().getFullYear();

  return (
    <footer className={`mt-auto border-t border-[var(--border)] bg-[var(--sidebar-bg)] ${className}`}>
      <div className="max-w-5xl mx-auto px-5 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <p className="text-xs text-[var(--text-muted)]">
          © {year} PsyPractice · {t("rights")}
        </p>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {LEGAL_LINKS.map((l) => (
            <Link
              key={l.id}
              href={`${legalBase}#${l.id}`}
              className="text-xs text-[var(--text-muted)] hover:text-[var(--accent)] transition-colors"
            >
              {t(l.key)}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
